import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../auth.service';
import { of, switchMap } from 'rxjs';

export const YaGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const authService = inject(AuthService);

    return authService.checkAuth().pipe(
        switchMap((authenticated) => {
            // If the user is not authenticated...
            if (!authenticated) {
                // Redirect to the sign-in page with a redirectUrl param
                const redirectURL =
                    state.url === '/sign-out'
                        ? ''
                        : `redirectURL=${state.url}`;
                const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                return of(urlTree);
            }
            sessionStorage.setItem('market', 'ya');

            if (!authService.market('ya')) {
                // If the user is not using the Yandex app, redirect to the sign-in page
                const urlTree = router.parseUrl(`select-market?redirectURL=${state.url}`);
                return of(urlTree);
            }

            // Allow the access
            return of(true);
        })
    )
}
